import React from 'react'
import './RecStructure.css'

const RecStructure = ({ RecData }) => {
    return (
        <div className="app__table_rec">
             <h2 className="rec__table-header">RECREATION MATCH STRUCTURE</h2>
            <table className="app__background-bk rec__table ">
                <thead className="rec__table_thead">
                    <tr className="rec__table_tr">
                        <th className="h4__roboto rec__th">Age Group</th>
                        <th className="h4__roboto rec__th">Match Length</th>
                        <th className="h4__roboto rec__th">Ball Size</th>
                        <th className="h4__roboto rec__th">Team Size</th>
                        <th className="h4__roboto rec__th">Offsides Rule</th>
                        <th className="h4__roboto rec__th">Headers</th>
                        <th className="h4__roboto rec__th">Youth Official</th>
                    </tr>
                </thead>
                <tbody className="rec__table_tbody">
                    {RecData.map((row, index) => (
                        <tr className="rec__table_tr" key={index}>
                            <td className="pData">{row.age}</td>
                            <td className="pData">{row.matchLength}</td>
                            <td className="pData">{row.ballSize}</td>
                            <td className="pData">{row.teamSize}</td>
                            <td className="pData">{row.offsideRule}</td>
                            <td className="pData">{row.headers}</td>
                            <td className="pData">{row.official}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}


export default RecStructure